import { replaceClientDataUrlRouteQueryVariables } from '@portal-internet/core';
import Enllac from 'components/corporatiu/Enllac';
import Slider from 'components/corporatiu/Slider';
import { useLoading } from 'hooks/corporatiu/useLoading';
import { getUrlFriendly } from 'components/corporatiu/Enllac/RouteResolver';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './menuseccio.module.scss';

const Seccio = (props) => {
    const { item, routerQuery } = props;
    const { url, type, slug, slug2, id, titol } = item;

    if (__isEmpty(url) && __isEmpty(type)) return <></>;

    const seccio = replaceClientDataUrlRouteQueryVariables(props.seccio, routerQuery);
    const cleanUrl = !__isEmpty(url)
        ? url.replace(/\/$/, '').split(/[?#]/)[0]
        : getUrlFriendly({
              routePath: type,
              id,
              slug,
              slug2
          });

    const isSelect =
        cleanUrl.endsWith(`/${seccio}`) ||
        cleanUrl.endsWith(`/${seccio}/`) ||
        seccio === slug2 ||
        routerQuery?.pathPage === url ||
        seccio === item?.titol;
    const stylesLink = clsx({
        [styles.link]: true,
        [styles.active]: isSelect
    });

    if (__isEmpty(titol)) return <></>;
    const route = {
        href: url,
        type,
        id,
        slug,
        slug2
    };

    let Tag = props.tagItemSeleccionat;

    if (__isEmpty(Tag)) Tag = 'span';

    return (
        <Enllac className={stylesLink} route={route} dataTestId={`menu-seccio-${slug || slug2}`}>
            {isSelect ? <Tag aria-current={true}>{titol}</Tag> : titol}
        </Enllac>
    );
};

const MenuSeccio = (props) => {
    const { seccio, tipus, items, routerQuery, tagItemSeleccionat, amagarOnLoading, portal } = props;
    const { activeLoading } = useLoading();

    const stylesMenu = clsx({
        [styles.menuItems]: true,
        [styles.contentHidden]: amagarOnLoading && activeLoading.active
    });

    return !__isEmpty(items) ? (
        <>
            <Slider tipus='menu' className={stylesMenu}>
                {items.map((item, i) => (
                    <Seccio
                        item={item}
                        routerQuery={routerQuery}
                        seccio={seccio}
                        key={`item-menu-seccio-${portal}-${i}`}
                        tagItemSeleccionat={tagItemSeleccionat}
                    />
                ))}
            </Slider>
        </>
    ) : (
        <></>
    );
};

export default MenuSeccio;
